namespace SolovisGateway.Admin.Authentication {
    export class ExternalAuthAppOrganizationModel {
        id: number;
        code: string;
        name: string;

        constructor(data: any) {
            if (data) {
                this.id = data.organizationId || data.id;
                this.code = data.organizationCode || data.code;
                this.name = data.organizationName || data.name;
            }
        }

        toDeleteParams(externalAuthAppCode: string): { externalAuthAppCode: string, organizationId: number, } {
            return {
                externalAuthAppCode: externalAuthAppCode,
                organizationId: this.id
            };
        }

        toAddParams(externalAuthAppCode: string): { externalAuthAppCode: string, organizationId: number, } {
            return {
                externalAuthAppCode: externalAuthAppCode,
                organizationId: this.id
            };
        }
    }
}